export const LOCALES_LOADED = 'LOCALES_LOADED';
export const ON_CONFIRM_DIALOG_OPEN = 'ON_CONFIRM_DIALOG_CONFIRM';
export const ON_CONFIRM_DIALOG_HIDE = 'ON_CONFIRM_DIALOG_HIDE';
export const ON_PDF_MODAL_OPEN = 'pdf-modal-open';
export const ON_PDF_MODAL_CLOSE = 'pdf-modal-close';
export const ON_QR_CODE_MODAL_OPEN = 'qr-code-modal-open';
export const ON_QR_CODE_MODAL_DATA_RETRIEVE = 'qr-code-modal-data-retrieve';
export const ON_QR_CODE_READER_MODAL_OPEN = 'qr-code-reader-modal-open';
export const ON_PDF_MODAL_DATA_RETRIEVE = 'pdf-modal-data-retrieve';
export const ON_CUSTOMER_DASHBOARD_DATE_CHANGE = 'customer-dashboard-date-change';
export const ON_INVOICES_TABLE_GET_TABLE_DATA = 'invoices-table-get-table-data';
export const ON_CHECKS_TABLE_GET_TABLE_DATA = 'checks-table-get-table-data';
export const ON_BACS_TABLE_GET_TABLE_DATA = 'bacs-table-get-table-data';
export const ON_SETTLEMENTS_TABLE_GET_TABLE_DATA = 'settlements-table-get-table-data'
export const ON_SEPA_TABLE_GET_TABLE_DATA = 'sepa-table-get-table-data'
export const ON_CLEAR_FILE_UPLOADER_INPUT = 'clear-file-uploader-input';
export const LOTS_TABLE_CLEAR_SELECTED = 'lots-table-clear-selected'
export const ON_RESERVATION_MODAL_SAVE = 'on-reservation-modal-save';
export const ON_CAMERA_MODAL_OPEN = 'camera-modal-open';
export const ON_AUCTIONEERS_SHEET_GENERATED = 'auctioneers_sheet_generated';
export const ON_AUCTIONEERS_SHEET_LOCKED = 'auctioneers_sheet_locked';
export const ON_UNSOLD_LOT_PROPOSAL_INPUT = 'on-unsold-lot-proposal-input'
export const ON_UNSOLD_LOT_PROPOSAL_BULK_INPUT = 'on-unsold-lot-proposal-bulk-input'
export const ON_UNSOLD_LOT_PROPOSAL_ERROR = 'on-unsold-lot-proposal-error'
export const ON_TRANSFER_NOTE_ITEM_SUBMIT = 'transfer-note-item-submit';
export const ON_INVOICE_PAYMENT_TABLE_GET_TABLE_DATA = 'invoices-payments-table-get-table-data';
export const ON_SETTLEMENT_PAYMENT_TABLE_GET_TABLE_DATA = 'settlements-payments-table-get-table-data';
export const UPDATE_ITEM_LOCATION_MOVE_MODAL_DATA = 'update-item-location-move-modal-data';
export const ON_CONFIRM_WITH_COMMENT_DIALOG_OPEN = 'ON_CONFIRM_WITH_COMMENT_DIALOG_CONFIRM';
export const ON_CONFIRM_WITH_COMMENT_DIALOG_HIDE = 'ON_CONFIRM_WITH_COMMENT_DIALOG_HIDE';
